<p-sidebar [(visible)]="showSidebar" styleClass="p-sidebar-md">
  <app-user-feedback-edit-dialog
    *ngIf="showSidebar"
    [disabled]="disabled"
    (saved)="save($event)"
    (closed)="close()"
  ></app-user-feedback-edit-dialog>
</p-sidebar>
